export default class XCloseButtonEvent extends Event {
	public static CLOSE = 'XCloseButtonEvent.close';

	public constructor() {
		super(XCloseButtonEvent.CLOSE, { bubbles: true });
	}
}
